import { Component } from "vue-property-decorator"

import FBannerBase from "./fBanner.client.base"

@Component
export default class FBannernWeb extends FBannerBase {}
